import { apolloClient } from "../../../src/graphql/apolloClient";
import {
  PRODUCT_YEAR_QUERY,
  PRODUCT_META_HS12,
} from "../../../src/pages/rankings/productRankings/queries";
import { CPProductClass } from "../../../src/types/countryProfileEnums";

// Prefetch the product-year data and HS12 metadata into the shared Apollo
// cache. The component filters by year client-side, so a single prefetch
// covers all /rankings/product/:year? routes.
export async function clientLoader() {
  await Promise.all([
    apolloClient.query({
      query: PRODUCT_YEAR_QUERY,
      variables: { productLevel: 4, productClass: String(CPProductClass.HS12) },
      fetchPolicy: "cache-first",
    }),
    apolloClient.query({
      query: PRODUCT_META_HS12,
      fetchPolicy: "cache-first",
    }),
  ]);
  return null;
}
clientLoader.hydrate = false as const;

// Product rankings: /rankings/product/:year?
// Stub for typegen — runtime routing handled by RankingsLayout
export default function ProductRankings() {
  return null;
}
